import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "row gx-3" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "table table-borderless" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { key: 5 }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "table table-borderless" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { key: 4 }
const _hoisted_23 = { key: 5 }
const _hoisted_24 = { key: 6 }
const _hoisted_25 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_26 = { class: "table table-bordered table-striped" }
const _hoisted_27 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_28 = { class: "table table-bordered table-striped" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Détails de la créance", -1)),
            _createVNode(_component_router_link, {
              to: "/creances/liste-creances",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                _createElementVNode("span", { class: "position-relative" }, "Retour", -1)
              ])),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("tbody", null, [
                  (_ctx.creance?.refCrean)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                        _cache[2] || (_cache[2] = _createElementVNode("td", { class: "fw-semibold" }, "Référence de la créance :", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.creance.refCrean), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.creance?.date)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                        _cache[3] || (_cache[3] = _createElementVNode("td", { class: "fw-semibold" }, "Date de la créance :", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.format_Date(_ctx.creance.date)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.creance?.client)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                        _cache[4] || (_cache[4] = _createElementVNode("td", { class: "fw-semibold" }, "Client :", -1)),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.creance?.client.nomClient && _ctx.creance?.client.prenomClient ? `${_ctx.creance?.client.nomClient} ${_ctx.creance?.client.prenomClient}` : _ctx.creance?.client.raisonSociale), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.creance?.montant)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                        _cache[5] || (_cache[5] = _createElementVNode("td", { class: "fw-semibold" }, "Montant total de la créance :", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.separateur(_ctx.creance.montant)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.creance?.reste_a_payer !== undefined)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                        _cache[6] || (_cache[6] = _createElementVNode("td", { class: "fw-semibold" }, "Reste à payer :", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.separateur(_ctx.creance.reste_a_payer)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.creance?.motifCreance)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                        _cache[7] || (_cache[7] = _createElementVNode("td", { class: "fw-semibold" }, "Motif de la créance :", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.creance.motifCreance), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("table", _hoisted_17, [
                _createElementVNode("tbody", null, [
                  (_ctx.creance?.refCommande)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                        _cache[8] || (_cache[8] = _createElementVNode("td", { class: "fw-semibold" }, "Références des commandes :", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.creance.refCommande), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.creance?.montantTotalCommandes)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                        _cache[9] || (_cache[9] = _createElementVNode("td", { class: "fw-semibold" }, "Montant total des commandes :", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.separateur(_ctx.creance.montantTotalCommandes)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.creance?.montantRegle)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                        _cache[10] || (_cache[10] = _createElementVNode("td", { class: "fw-semibold" }, "Montant réglé :", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.separateur(_ctx.creance.montantRegle)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.creance?.dureeCreance)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                        _cache[11] || (_cache[11] = _createElementVNode("td", { class: "fw-semibold" }, "Durée de créance (jours) :", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.creance.dureeCreance), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.creance?.modeReglement)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                        _cache[12] || (_cache[12] = _createElementVNode("td", { class: "fw-semibold" }, "Mode de règlement :", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.creance?.modeReglement.libelle), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.creance?.autresinfos)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                        _cache[13] || (_cache[13] = _createElementVNode("td", { class: "fw-semibold" }, "Autres informations :", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.creance.autresinfos), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.creance?.nbreEcheance)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                        _cache[14] || (_cache[14] = _createElementVNode("td", { class: "fw-semibold" }, "Nombre d'échéances :", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.creance.nbreEcheance), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.creance?.echeances?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _cache[16] || (_cache[16] = _createElementVNode("h5", { class: "mt-3" }, "Échéances", -1)),
                  _createElementVNode("table", _hoisted_26, [
                    _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Date Échéance"),
                        _createElementVNode("th", null, "Montant"),
                        _createElementVNode("th", null, "Reste à payer"),
                        _createElementVNode("th", null, "Statut")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creance.echeances, (echeance, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.format_Date(echeance.date)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.separateur(echeance.montant)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.separateur(echeance.reste_a_payer)), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(['badge', _ctx.getStatutBadge(echeance).class])
                            }, _toDisplayString(_ctx.getStatutBadge(echeance).text), 3)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.creance?.commandes?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _cache[18] || (_cache[18] = _createElementVNode("h5", { class: "mt-3" }, "Commandes liées à cette créance", -1)),
                  _createElementVNode("table", _hoisted_28, [
                    _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Référence"),
                        _createElementVNode("th", null, "Date Commande"),
                        _createElementVNode("th", null, "Montant TTC")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creance.commandes, (commande, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(commande.refCom), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.format_Date(commande.dateCommande)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.separateur(commande.montTTC)), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}